import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _VEHICLE_STATUS_TO_LA;

export var VEHICLE_STATUS = {
  DRAFT: 'DRAFT',
  STOCKED_IN: 'STOCKED_IN',
  FLOAT: 'FLOAT',
  IN_TRANSIT: 'IN_TRANSIT',
  INVOICE_RECEIVED: 'INVOICE_RECEIVED',
  IN_PRODUCTION: 'IN_PRODUCTION',
  ON_ORDER: 'ON_ORDER',
  SOLD: 'SOLD',
  RETIRED: 'RETIRED',
  RECEIVED: 'RECEIVED',
  ON_HOLD: 'ON_HOLD',
  CANCELLED: 'CANCELLED',
  RESERVED: 'RESERVED'
};
export var VEHICLE_RECON_STATUS = {
  WAITING_FOR_RECON: 'WAITING_FOR_RECON',
  IN_RECON: 'IN_RECON',
  INVENTORY_IN_STOCK: 'INVENTORY_IN_STOCK'
};
export var VEHICLE_STATUS_TO_LABEL = (_VEHICLE_STATUS_TO_LA = {}, _defineProperty(_VEHICLE_STATUS_TO_LA, VEHICLE_STATUS.DRAFT, __('Draft')), _defineProperty(_VEHICLE_STATUS_TO_LA, VEHICLE_STATUS.STOCKED_IN, __('Stocked In')), _defineProperty(_VEHICLE_STATUS_TO_LA, VEHICLE_STATUS.FLOAT, __('Float')), _defineProperty(_VEHICLE_STATUS_TO_LA, VEHICLE_STATUS.IN_TRANSIT, __('In Transit')), _defineProperty(_VEHICLE_STATUS_TO_LA, VEHICLE_STATUS.INVOICE_RECEIVED, __('Invoice Received')), _defineProperty(_VEHICLE_STATUS_TO_LA, VEHICLE_STATUS.IN_PRODUCTION, __('In Production')), _defineProperty(_VEHICLE_STATUS_TO_LA, VEHICLE_STATUS.ON_ORDER, __('On Order')), _defineProperty(_VEHICLE_STATUS_TO_LA, VEHICLE_STATUS.SOLD, __('Sold')), _defineProperty(_VEHICLE_STATUS_TO_LA, VEHICLE_STATUS.RETIRED, __('Retired')), _defineProperty(_VEHICLE_STATUS_TO_LA, VEHICLE_STATUS.ON_HOLD, __('On Hold')), _defineProperty(_VEHICLE_STATUS_TO_LA, VEHICLE_STATUS.RECEIVED, __('Received')), _defineProperty(_VEHICLE_STATUS_TO_LA, VEHICLE_STATUS.CANCELLED, __('Cancelled')), _defineProperty(_VEHICLE_STATUS_TO_LA, VEHICLE_STATUS.RESERVED, __('Reserved')), _VEHICLE_STATUS_TO_LA);
export var VEHICLE_STATUS_OPTIONS = Object.keys(VEHICLE_STATUS_TO_LABEL).map(function (key) {
  return {
    label: VEHICLE_STATUS_TO_LABEL[key],
    value: key
  };
});
export var INVENTORY_STATUS_OPTIONS = [{
  label: VEHICLE_STATUS_TO_LABEL[VEHICLE_STATUS.DRAFT],
  value: VEHICLE_STATUS.DRAFT
}, {
  label: VEHICLE_STATUS_TO_LABEL[VEHICLE_STATUS.IN_TRANSIT],
  value: VEHICLE_STATUS.IN_TRANSIT
}, {
  label: VEHICLE_STATUS_TO_LABEL[VEHICLE_STATUS.FLOAT],
  value: VEHICLE_STATUS.FLOAT
}, {
  label: VEHICLE_STATUS_TO_LABEL[VEHICLE_STATUS.STOCKED_IN],
  value: VEHICLE_STATUS.STOCKED_IN
}, {
  label: VEHICLE_STATUS_TO_LABEL[VEHICLE_STATUS.ON_HOLD],
  value: VEHICLE_STATUS.ON_HOLD
}, // commenting this fields for now as this is not functional currently , will be implemented in future do not delete
// {
//   label: __('On Order'),
//   value: VEHICLE_STATUS.ON_ORDER,
// },
{
  label: VEHICLE_STATUS_TO_LABEL[VEHICLE_STATUS.SOLD],
  value: VEHICLE_STATUS.SOLD
}, // commenting this fields for now as this is not functional currently , will be implemented in future do not delete
// {
//   label: __('Retired'),
//   value: VEHICLE_STATUS.RETIRED,
// },
{
  label: VEHICLE_STATUS_TO_LABEL[VEHICLE_STATUS.INVOICE_RECEIVED],
  value: VEHICLE_STATUS.INVOICE_RECEIVED
}, {
  label: VEHICLE_STATUS_TO_LABEL[VEHICLE_STATUS.RECEIVED],
  value: VEHICLE_STATUS.RECEIVED
}, {
  label: VEHICLE_STATUS_TO_LABEL[VEHICLE_STATUS.CANCELLED],
  value: VEHICLE_STATUS.CANCELLED
}, {
  label: VEHICLE_STATUS_TO_LABEL[VEHICLE_STATUS.RESERVED],
  value: VEHICLE_STATUS.RESERVED
}];